import { Check } from "lucide-react";

export interface WizardStep {
  id: string;
  label: string;
}

export function WizardRail({
  steps,
  activeIndex,
  isNavigable,
  onStepSelect,
}: {
  steps: WizardStep[];
  activeIndex: number;
  isNavigable?: (index: number) => boolean;
  onStepSelect?: (index: number) => void;
}) {
  return (
    <ol className="mb-4 flex shrink-0 list-none flex-wrap gap-2">
      {steps.map((step, index) => {
        const state =
          index < activeIndex ? "done" : index === activeIndex ? "now" : "todo";

        const wrapper =
          state === "done"
            ? "border-success/35 text-success"
            : state === "now"
              ? "border-accent text-foreground"
              : "border-muted text-foreground/70";

        const marker =
          state === "done"
            ? "bg-success text-background"
            : state === "now"
              ? "bg-accent text-surface"
              : "bg-muted text-foreground/70";

        const navigable =
          index !== activeIndex && (isNavigable?.(index) ?? false);

        const content = (
          <>
            <span
              className={`inline-flex size-4.5 items-center justify-center rounded-full text-2xs ${marker}`}
              aria-hidden="true"
            >
              {state === "done" ? (
                <Check className="h-2.5 w-2.5" strokeWidth={3} />
              ) : (
                index + 1
              )}
            </span>
            {step.label}
          </>
        );

        const shared = `flex items-center gap-2 rounded-full border px-2.5 py-1 text-xs ${wrapper}`;

        return (
          <li key={step.id} aria-current={state === "now" ? "step" : undefined}>
            {navigable ? (
              <button
                type="button"
                onClick={() => onStepSelect?.(index)}
                className={`${shared} hover:border-accent hover:text-foreground`}
              >
                {content}
              </button>
            ) : (
              <span className={shared}>{content}</span>
            )}
          </li>
        );
      })}
    </ol>
  );
}
